if (!customElements.get("cart-product-carousel")) {
    
    class CartProductCarousel extends HTMLElement {
        constructor() {
            super(),
                (this.container = this),
                (this.track = this.querySelector(".carousel__track")),
                (this.slides = Array.from(this.querySelectorAll(".carousel__slide"))),
                (this.prevButton = this.querySelector(".carousel__button--prev")),
                (this.nextButton = this.querySelector(".carousel__button--next")),
                (this.currentIndex = 0),
                (this.slideWidth = 0),
                (this.gap = 20),
                (this.visibleSlides = 2.5),
                (this.isDragging = !1),
                (this.startX = 0),
                (this.currentTranslate = 0),
                (this.prevTranslate = 0),
                (this.animationID = 0);
                if(!this.isScriptAlreadyIncluded('product-form.js')){
                    //includeScript(this.container.dataset.productForm);
                }
        }
        isScriptAlreadyIncluded(src) {
            const scripts = document.getElementsByTagName("script");
            for (let i = 0; i < scripts.length; i++) {
                // Check if the script src contains the filename
                if (scripts[i].getAttribute('src') && scripts[i].getAttribute('src').includes(src)) {
                return true;
                }
            }
            return false;
        }
        includeScript(scriptSrc) {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.async = true; // Optional: load script asynchronously
            document.head.appendChild(script); // Or document.body.appendChild(script);
            console.log(`${scriptSrc} has been included.`);
        }
        connectedCallback() {
            this.calculateDimensions(),
                this.updateSlides(),
                window.innerWidth <= 767 &&
                    this.slides.forEach((t) => {
                        t.classList.add("no-hover");
                    }),
                this.addEventListeners(),
                (this.resizeObserver = new ResizeObserver(() => {
                    this.calculateDimensions(), this.updateSlides();
                })),
                this.resizeObserver.observe(this.container);
        }
        disconnectedCallback() {
            this.removeEventListeners(), this.resizeObserver?.disconnect();
        }
        calculateDimensions() {
            this.slides.length !== 0 && (this.slideWidth = this.slides[0].offsetWidth + this.gap);
        }
        updateSlides() {
            const t = this.currentIndex * this.slideWidth;
            (this.track.style.transition = "transform 0.3s ease"),
                (this.track.style.transform = `translateX(-${t}px)`),
                this.updateButtons();
        }
        updateButtons() {
            this.prevButton && (this.prevButton.disabled = this.currentIndex === 0),
                this.nextButton &&
                    (this.nextButton.disabled = this.currentIndex >= this.slides.length - this.visibleSlides);
        }
        nextSlide() {
            this.currentIndex < this.slides.length - this.visibleSlides && (this.currentIndex++, this.updateSlides());
        }
        prevSlide() {
            this.currentIndex > 0 && (this.currentIndex--, this.updateSlides());
        }
        addEventListeners() {
            this.prevButton?.addEventListener("click", () => this.prevSlide()),
                this.nextButton?.addEventListener("click", () => this.nextSlide()),
                this.track.addEventListener("touchstart", this.touchStart.bind(this), { passive: !0 }),
                this.track.addEventListener("touchmove", this.touchMove.bind(this), { passive: !1 }),
                this.track.addEventListener("touchend", this.touchEnd.bind(this)),
                this.track.addEventListener("mousedown", this.touchStart.bind(this)),
                this.track.addEventListener("mousemove", this.touchMove.bind(this)),
                this.track.addEventListener("mouseup", this.touchEnd.bind(this)),
                this.track.addEventListener("mouseleave", this.touchEnd.bind(this));
        }
        removeEventListeners() {
            this.prevButton?.removeEventListener("click", () => this.prevSlide()),
                this.nextButton?.removeEventListener("click", () => this.nextSlide());
        }
        touchStart(t) {
            (this.isDragging = !0), (this.track.style.transition = "none");
            const s = t.type.includes("mouse") ? t : t.touches[0];
            (this.startX = s.clientX),
                (this.startY = s.clientY),
                (this.currentX = this.startX),
                (this.currentY = this.startY),
                (this.isHorizontalDrag = null),
                (this.prevTranslate = -this.currentIndex * this.slideWidth);
        }
        touchMove(t) {
            if (!this.isDragging) return;
            const s = t.type.includes("mouse") ? t : t.touches[0],
                e = s.clientX - this.startX,
                i = s.clientY - this.startY;
            if (
                (this.isHorizontalDrag === null &&
                    (Math.abs(e) > 5 || Math.abs(i) > 5) &&
                    (this.isHorizontalDrag = Math.abs(e) > Math.abs(i)),
                this.isHorizontalDrag === !1)
            )
                return;
            t.type === "touchmove" && t.preventDefault();
            const r = this.prevTranslate + e;
            this.track.style.transform = `translateX(${r}px)`;
        }
        touchEnd(t) {
            if (!this.isDragging || ((this.isDragging = !1), this.isHorizontalDrag === !1)) return;
            const e = (t.type.includes("mouse") ? t : t.changedTouches[0]).clientX - this.startX,
                i = this.slideWidth / 4;
            e > i && this.currentIndex > 0
                ? this.prevSlide()
                : e < -i && this.currentIndex < this.slides.length - this.visibleSlides
                  ? this.nextSlide()
                  : this.updateSlides();
        }
    }
    customElements.define("cart-product-carousel", CartProductCarousel);
}